import { AUTH_SERVER_HOST } from "../../../../../../config";
import checkHttpResponse from "./checkHttpResponse";

export default async function checkLoginServerTriState(): Promise<"OK" | "ADEQUATE" | "BAD"> {
  const result = await checkHttpResponse(`${AUTH_SERVER_HOST}/info`);
  if (result) return "OK";
  return "BAD";
}
